module.exports = __webpack_public_path__ + "static/media/km.feaefd5e.svg";